
import { Vue, Component, Ref } from 'vue-property-decorator';
import SPUService from '@/services/spu.service';
import lazyInject from '@/di';
import { ISPUCategory } from '@/common/interface/spu';
import ImageManagementModal from './components/ImageManagementModal.vue';

@Component({
  components: {
    ImageManagementModal,
  },
})
export default class ClassificationImageManagement extends Vue {
  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Ref('imageManagementModal')
  imageManagementModal!: ImageManagementModal;

  dataSource: any = [];

  visible = false;
  form: any = {
    onSiteService: undefined,
    id: '',
  };

  allSpuCategory: ISPUCategory[] = [];
  secondCategoryList: ISPUCategory[] = [];

  columns = [
    {
      title: '类目',
      dataIndex: 'name',
      // align: 'center',
      width: 400,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      scopedSlots: { customRender: 'actions' },
      align: 'center',
      width: 200,
    },
  ];

  imageManage(val: any) {
    console.log(val);
    this.$router.push({
      name: 'spu.productImageManagement',
      params: {
        categoryId: val.id,
      },
    });
  }

  showImageModal(val: any) {
    const res = this.dataSource.find((item: any) => item.id === val.pid);
    const data = {
      pName: res.name,
      ...val,
    };
    delete data.default_item;
    this.imageManagementModal.init(data, val);
  }

  async handleOk() {
    try {
      const res = await this.spuService.editOnSiteService(this.form);
      if (res) {
        this.visible = false;
        this.$message.success('修改成功');
        this.getList();
        this.form.onSiteService = undefined;
        this.form.id = '';
      }
    } catch (error) {
      return error;
    }
  }

  async getList() {
    const res = await this.spuService.getShopDetailItemListBySpuId({
      aggregation: true,
    });
    this.dataSource = res;
  }
  async getCategory() {
    const data = await this.spuService.spuCategories({
      aggregation: true,
      loadingEl: this.$el,
    });

    this.allSpuCategory = data;

    this.secondCategoryList = data.reduce((prev, cur) => {
      return prev.concat(cur.children || []);
    }, [] as ISPUCategory[]);
  }
  mounted() {
    this.getCategory();
    this.getList();
  }
}
